import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Typography from 'src/common/components/Typography';
import AppLinks from 'src/common/components/AppLinks';
import Image from 'next/image';
import { relativeLoader } from 'src/common/utils/imageHelpers';
import { NEXT_STATIC_IMAGES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import styles from './MobileAppsHero.module.scss';

const MobileAppsHero: FC = () => {
  const [t] = useTranslation('mobile-apps-page');
  return (
    <div className={styles.root}>
      <PitchPageLayout
        backgroundColor="ivory"
      >
        <div className={styles.appIcon}>
          <Image
            src={`${NEXT_STATIC_IMAGES}mobile-apps/app-icon-ios.svg`}
            alt={t('app-icon-alt')}
            width={60}
            height={60}
          />
        </div>
        <div className={styles.main}>
          <div className={styles.text}>
            <Typography
              type="h1"
              size="display-4"
              sizeFromBreakpointM="display-3"
            >
              {t('hero-title')}
            </Typography>
            <Typography
              type="h2"
              size="body-xl"
            >
              {t('hero-subtitle')}
            </Typography>
          </div>
          <AppLinks classNameModifier="pitchPageMobileApps" />
          <Image
            src={`${NEXT_STATIC_IMAGES}mobile-apps/mobile-apps-hero.jpg`}
            alt={t('hero-img-alt')}
            width={565}
            height={533}
            loader={relativeLoader}
            className={styles.image}
            loading="eager"
          />
        </div>
      </PitchPageLayout>
    </div>
  );
};

export default MobileAppsHero;
